module.exports = __webpack_public_path__ + "static/media/google-login-573x102.0cdb568c.png";